import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function DetailsPageCard({
  actions,
  children,
  title,
  id
}) {
  return /*#__PURE__*/_jsxs(View, {
    marginBlockEnd: "600",
    padding: "1000",
    backgroundColor: "fill-surface-default",
    borderRadius: "300",
    borderColor: "border-core-subtle",
    borderStyle: "solid",
    borderWidth: "100",
    overflow: "hidden",
    position: "relative",
    id: id,
    children: [title ? /*#__PURE__*/_jsxs(Flex, {
      justifyContent: "space-between",
      alignItems: "end",
      paddingBlockEnd: "400",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h4",
        paddingBlockStart: "0",
        children: title
      }), actions && actions]
    }) : null, children]
  });
}